<div
  mat-dialog-title
  appDraggableDialog
  draggableKey="line-point"
  [draggableWithRestrictArea]="true"
  dialogClass=".q9-line-point">
  <span>{{ 'POPUPS.CHOOSE_POINTS_OPTIONS' | translate }}</span>
</div>

<mat-dialog-content class="btn-set">
  <div class="btn-set--selector">
    <div>{{ 'ASIDE_R.FORM_START' | translate }}</div>
    <div class="btn-set--form">
      <app-form-buttonset
        [forms]="forms.start"
        [selected]="form?.start"
        (setClicked)="onSetStart($event)"></app-form-buttonset>
    </div>
  </div>
  <div class="btn-set--selector">
    <div>{{ 'ASIDE_R.FORM_END' | translate }}</div>
    <div class="btn-set--form">
      <app-form-buttonset
        [forms]="forms.end"
        [selected]="form?.end"
        (setClicked)="onSetEnd($event)"></app-form-buttonset>
    </div>
  </div>
</mat-dialog-content>
